import breachOfTrustFA from './fa/fa.json'

const BreachOfTrustMessages = {
  fa: { ...breachOfTrustFA },
}

export default BreachOfTrustMessages
